<template>
  <div class="wc-ui-config">
    <byted-wc-config-provider v-wc-bind="wcConfigProps" />
    <byted-wc-business-config-provider v-wc-bind="wcBusinessConfigProps" />
  </div>
</template>

<script>
import '@byted/wc-ui/wc-ui/wc-ui.css'

import { getLang, isRtlLangue, Locale2WcUiLangMap } from '@/utils/unicodeUtil'
import { captureException } from '@/utils/slardar'

const WcUiLocalesRequireFnMap = {
  ar: {
    requireFn: () => import('@byted/wc-ui/locales/ar.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/ar.js'),
  },
  'cs-CZ': {
    requireFn: () => import('@byted/wc-ui/locales/cs-CZ.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/cs-CZ.js'),
  },
  'de-DE': {
    requireFn: () => import('@byted/wc-ui/locales/de-DE.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/de-DE.js'),
  },
  'en-GB': {
    requireFn: () => import('@byted/wc-ui/locales/en-GB.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/en-GB.js'),
  },
  'es-ES': {
    requireFn: () => import('@byted/wc-ui/locales/es-ES.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/es-ES.js'),
  },
  'fr-FR': {
    requireFn: () => import('@byted/wc-ui/locales/fr-FR.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/fr-FR.js'),
  },
  'id-ID': {
    requireFn: () => import('@byted/wc-ui/locales/id-ID.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/id-ID.js'),
  },
  'it-IT': {
    requireFn: () => import('@byted/wc-ui/locales/it-IT.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/it-IT.js'),
  },
  'ja-JP': {
    requireFn: () => import('@byted/wc-ui/locales/ja-JP.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/ja-JP.js'),
  },
  'ko-KR': {
    requireFn: () => import('@byted/wc-ui/locales/ko-KR.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/ko-KR.js'),
  },
  'ms-MY': {
    requireFn: () => import('@byted/wc-ui/locales/ms-MY.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/ms-MY.js'),
  },
  'pt-BR': {
    requireFn: () => import('@byted/wc-ui/locales/pt-BR.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/pt-BR.js'),
  },
  'ru-RU': {
    requireFn: () => import('@byted/wc-ui/locales/ru-RU.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/ru-RU.js'),
  },
  'th-TH': {
    requireFn: () => import('@byted/wc-ui/locales/th-TH.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/th-TH.js'),
  },
  'tr-TR': {
    requireFn: () => import('@byted/wc-ui/locales/tr-TR.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/tr-TR.js'),
  },
  'vi-VN': {
    requireFn: () => import('@byted/wc-ui/locales/vi-VN.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/vi-VN.js'),
  },
  'zh-CN': {
    requireFn: () => import('@byted/wc-ui/locales/zh-CN.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/zh-CN.js'),
  },
  'mn-MN': {
    requireFn: () => import('@byted/wc-ui/locales/mn-MN.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/mn-MN.js'),
  },
  'pl-PL': {
    requireFn: () => import('@byted/wc-ui/locales/pl-PL.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/pl-PL.js'),
  },
  'sv-SE': {
    requireFn: () => import('@byted/wc-ui/locales/sv-SE.js'),
    requireFnB: () => import('@byted/wc-business-ui/locales/sv-SE.js'),
  },
};

export default {
  name: 'WcUiConfig',
  components: {},
  data() {
    return {
      wcConfigProps: {},
      wcBusinessConfigProps: {},
    }
  },
  created() {
    this.fetchWcUiLang()
  },
  methods: {
    async fetchWcUiLang() {
      const lang = getLang()
      // 如果有无 match 语言的异常，兜底使用英文
      if (!Locale2WcUiLangMap[lang]) {
        captureException(`wc-ui-config missing lang: ${lang}`);
        this.$emit('ready', true)
        return;
      }
      try {
        const [
          // { default: WcUiLocales },
          { default: WcBusinessUiLocales },
        ] = await Promise.all([
          //wc-ui 的多语言暂时没有用到，需要时打开
          // WcUiLocalesRequireFnMap[Locale2WcUiLangMap[lang]].requireFn(),
          WcUiLocalesRequireFnMap[Locale2WcUiLangMap[lang]].requireFnB(),
        ])
        const direction = isRtlLangue() ? 'rtl' : 'ltr'
        this.wcConfigProps = {
          // locale: WcUiLocales,
          direction,
        }
        this.wcBusinessConfigProps = {
          locale: WcBusinessUiLocales,
          direction,
        }
      } catch (error) {
        // 如果有无 match 语言的异常，兜底使用英文，并上报 slardar
        captureException(error)
      }
      this.$emit('ready', true)
    },
  },
}
</script》>
<style></style>
